import { gql } from '../../__generated__/gql'

export const STORE_SONGS_QUERY = gql(`
  query storeSongsListQuery(
    $q: String
    $page: Int
    $perPage: Int
    $orderBy: SortSongsEnum
    $favorite: Boolean
  ) {
    storeSongs(
      q: $q
      page: $page
      perPage: $perPage
      orderBy: $orderBy
      favorite: $favorite
    ) {
      ...songFields
    }
  }
`)
